import { configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import servicesSlice from './servicesSlice';
import companiesSlice from './companiesSlice';
import claimsSlice from './claimsSlice';
import forgotPasswordSlice from './forgotPasswordSlice';
import managerSlice from './managerSlice';
import responsibleSlice from './responsibleSlice';
import suggestionSlice from './suggestionSlice';
import claimManagerSlice from './claimManagerSlice';
import claimHistorySlice from './claimHistorySlice';
import adminNotificationSlice from './notificationSlice';
import jobPostsSlice from './jobPostSlice';
import collaborationSlice from './collaborationSlice';
import areaSectionsSlice from './areaSectionsSlice';
import reservationSlice from './reservationSlice';
import serviceRequestSlice from './serviceRequestSlice';
import staffRatingSlice from './staffRatingSlice';
import staffMonthlyReviewSlice from './staffMonthlyReviewSlice';
import favoriteUsersSlice from './favoriteUsersSlice';
import attendanceSlice from './attendanceSlice';
import uiSlice from './uiSlice';
import { setStore } from './storeRef';

export const store = configureStore({
  reducer: {
    ui: uiSlice,
    user: authSlice,
    manager: managerSlice,
    claimManager: claimManagerSlice,
    responsible: responsibleSlice,
    services: servicesSlice,
    companies: companiesSlice,
    claims: claimsSlice,
    forgotPassword: forgotPasswordSlice,
    suggestions: suggestionSlice,
    notification: adminNotificationSlice,
    history: claimHistorySlice,
    jobPosts: jobPostsSlice,
    collaborations: collaborationSlice,
    areaSections: areaSectionsSlice,
    reservations: reservationSlice,
    serviceRequests: serviceRequestSlice,
    staffRating: staffRatingSlice,
    staffMonthlyReview: staffMonthlyReviewSlice,
    favoriteUsers: favoriteUsersSlice,
    attendance: attendanceSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

setStore(store);
